/**
 * Module accent colors used on subscription cards (signup + org settings).
 * Referenced by `moduleSubscriptionCatalog.js` MODULE_PRICING `.color`.
 */
export const MODULE_BRAND_HEX = {
  Accounting: "#2563eb",
  HR: "#7c3aed",
  Inventory: "#059669",
  Marketing: "#ea580c",
  Procurement: "#0891b2",
  Sales: "#db2777",
  /** Manufacturing / shop floor (roadmap). */
  Production: "#ca8a04",
  /** Retail checkout & registers (roadmap). */
  PointOfSale: "#4338ca",
};
